export const getCurrentUrl = (): string => {
  const { search, pathname } = window.location;

  return `${pathname}${search ? `?${search}` : ''}`;
};
